import { useLazyGetWalletCardTemplateQuery, useCreateWalletCardTemplateMutation, useLazyGetWalletCardTemplateDetailQuery, useDeleteWalletCardTemplateMutation, useUpdateWalletCardTemplateMutation } from '../../../../../services/cellcast.v2'

export function useWalletCardApi() {
  const [getWalletCardList, getWalletCardListState] = useLazyGetWalletCardTemplateQuery()
  const [deleteWalletCardTemplate, deleteWalletCardTemplateState] = useDeleteWalletCardTemplateMutation()
  const [createWalletCardTemplate, createWalletCardTemplateState] = useCreateWalletCardTemplateMutation()
  const [getWalletCardTemplateDetail, getWalletCardTemplateDetailState] = useLazyGetWalletCardTemplateDetailQuery()
  const [updateWalletCardTemplate, updateWalletCardTemplateState] = useUpdateWalletCardTemplateMutation()
  return {
    getWalletCardList,
    getWalletCardListState,
    createWalletCardTemplate,
    createWalletCardTemplateState,
    deleteWalletCardTemplate,
    deleteWalletCardTemplateState,
    getWalletCardTemplateDetail,
    getWalletCardTemplateDetailState,
    updateWalletCardTemplate,
    updateWalletCardTemplateState,
  }
}
